import BaseScene from './BaseScene';
import ButtonSprite from '../components/ButtonSprite';
import translate from '../components/LanguageManager';

export default class About extends BaseScene {

    constructor() {
        super({key: 'About'});
    }

    public init() {
        super.init();
    }

    public create() {
        super.create();

        // BG
        this.add.rectangle(this.width / 2, this.height / 2, 2000, 2000, parseInt('000000', 16)).setAlpha(0.7);
        
        // Panel
        const panel = this.add.image(0, 0,'game_panel_about').setScale(1.2);

        const text = translate.key('about_text');

        const aboutText = this.add.text(-10, -60, text)
            .setOrigin(0.5)
            .setWordWrapWidth(340)
            .setStyle({ 
                fontFamily: 'supersonic',
                fontSize: 22,
                color: '#3d3d3d',
                align: 'center',
            });

        const backButton = new ButtonSprite(this, -10, 270, 'button_back', 2, () => this.backToMainMenu());

        const container = this.add.container((this.width / 2) + 25, -300).add([panel, aboutText, backButton]);

        // Tween
        this.tweens.add({
            y: 460,
            targets: container,
            ease: 'Sine.easeInOut',
            duration: 500,
            repeat: 0,
        });

    }

    private backToMainMenu() {
        this.getBootloaderScene().stopScene('About');
        this.scene.resume('MainMenu');
    }
}
